import React, { FC, FunctionComponent } from 'react';
import ReactMarkdown from 'react-markdown';

import { SnippetRenderer } from './SnippetRenderer';

export interface ExcerptSnippetProps {
  excerpt: string;
  renderers?: {
    image: typeof SnippetRenderer;
    Replacer: FunctionComponent<React.PropsWithChildren<unknown>>;
  };
}

export const ExcerptSnippetReplacer: FC<{ children: React.ReactNode }> = ({ children }) => <div>{children}</div>;

const defaultRenderers = {
  image: SnippetRenderer,
  paragraph: ExcerptSnippetReplacer,
};

export const ExcerptSnippet: FC<React.PropsWithChildren<ExcerptSnippetProps>> = ({ excerpt, renderers = defaultRenderers }) => (
  <ReactMarkdown allowedTypes={['image']} renderers={renderers} unwrapDisallowed>
    {excerpt}
  </ReactMarkdown>
);
